import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'label-tooltip',
  shadow: false,
})
export class Label {
  @Prop() label: string;
  @Prop() tooltip: string;

  componentDidLoad() {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(tooltipTriggerEl => new (window as any).bootstrap.Tooltip(tooltipTriggerEl));
  }

  render() {
    return (
      <>
        <label class="form-label mb-1 fw-medium fs-label">{this.label}</label>
        <span class="ms-1" tabindex="0" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title={this.tooltip}>
          <i class="bi bi-info-circle text-info fs-label opacity-75 ms-2"></i>
        </span>
      </>
    );
  }
}
